<template>
  <div style="margin: 4px 16px 16px;">
    <div class="content-input" style="margin-bottom: 8px;">
      <div class="content-input-left">
        <div class="dialog-input-item" v-if="hygieneId == 0">
          <DatePickerRange title="打卡时间" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="dialog-input-item" v-if="hygieneId == 0">
          <label>打卡类型</label>
          <el-select v-model="type" placeholder="选择复用门店" class="select-item">
            <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="dialog-input-item" v-if="hygieneId > 0">
          <label>结果反馈</label>
          <el-select v-model="result" placeholder="选择复用门店" class="select-item">
            <el-option v-for="item in resultArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="content-input-right">
        <div class="dialog-input-btn">
          <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
        </div>
      </div>
    </div>
    <el-button v-if="(operateState & 32) == 32 && showOperate" type="primary" style="margin-bottom: 16px;" @click="bitchUpdate">批量审核</el-button>
    <el-table
        ref="multipleTableRef"
        :data="pageDataList"
        style="width: 100%; "
        v-loading="listLoading"
        @cell-click="toggleSelection"
        @selection-change="selsChange"
        @header-click="selsAll"
        size="default"
        border
    >
      <el-table-column type="selection" width="55" align="center" class-name="cursor"/>
      <el-table-column property="startDate" label="打卡时间">
        <template #default="scope">
          <p>{{scope.row.startDate}}<span v-if="scope.row.endDate && (scope.row.endDate != scope.row.startDate)">~{{scope.row.endDate}}</span></p>
        </template>
      </el-table-column>
      <el-table-column property="uploadTime" label="上传时间"/>
      <el-table-column property="shopName" label="所属门店"/>
      <el-table-column property="area" label="卫生打卡类型">
        <template #default="scope">
          {{scope.row.type == 1?'每日卫生打卡':scope.row.type == 2?'每周卫生打卡':scope.row.type == 3?'每月卫生打卡':'' }}
        </template>
      </el-table-column>
      <el-table-column property="area" label="区域"/>
      <el-table-column property="location" label="位置" />
      <el-table-column property="" label="区域卫生照片">
        <template #default="scope">
          <el-button type="primary" size="small" @click="checkHygieneImg(scope.row.detailImgList)">查看图片</el-button>
        </template>
      </el-table-column>
      <el-table-column property="location" label="结果反馈" >
        <template #default="scope">
          {{scope.row.result == 1?'不合格':scope.row.result == 2?'一般':scope.row.result == 3?'干净':scope.row.result == 4?'非常干净':'' }}
          <span v-if="scope.row.resultMsg">：{{scope.row.resultMsg}}</span>
        </template>
      </el-table-column>
      <el-table-column property="" label="操作" v-if="(operateState & 32) == 32 && showOperate">
        <template #default="scope">
          <el-button type="primary" size="small" @click="updateState(scope.row)">审核</el-button>
        </template>
      </el-table-column>
    </el-table>
<!--    分页-->
    <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalRow" style="text-align:right;margin-top: 24px;">
    </el-pagination>
  </div>
</template>

<script>
import {getFormData, postFormData} from '@/api/api';
import {getHygieneDetailPageList, updateHygieneDetailResult} from '@/api/url';
import SearchComponents from "@/components/SearchComponents";
import DatePickerRange from "@/components/DatePickerRange_7_1";
import Dialog from "@/assets/js/dialog";
import hygieneImgDialog from "@/views/hygiene/components/hygieneImgDialog";
import updateHygieneStateDialog from "@/views/hygiene/components/updateHygieneStateDialog";
import PetListDialog from "@/views/user/components/PetListDialog";
export default {
  props: {
    value: Object
  },
  components: {DatePickerRange, SearchComponents},
  data() {
    return {
      showOperate: this.value.showOperate,
      hygieneId: this.value.hygieneId,
      pageDataList: [],
      userForm: this.value.userForm,
      pageType: this.value.pageType,
      totalRow: 0,
      pageSize: 20,
      currentPage: 1,
      listLoading: false,
      searchLoading: false,

      typeArray: [
        {label: '不限', value: -1},
        {label: '每日卫生打卡', value: 1},
        {label: '每周卫生打卡', value: 2},
        {label: '每月卫生打卡', value: 3},
      ],
      type: -1,

      resultArray: [
        {label: '不限', value: -1},
        {label: '待审核', value: 0},
        {label: '不合格', value: 1},
        {label: '一般', value: 2},
        {label: '干净', value: 3},
        {label: '非常干净', value: 4},
      ],
      result: this.value.result,

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      shopIdArray: [],
      shopIdArr:[],
      shopId: this.value.shopId,
      reuseShopId: '',

      idArray: [],

      operateState: JSON.parse(sessionStorage.getItem('operateState')),

    }
  },
  methods: {

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },


    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },


    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['hygieneId'] = this.hygieneId;
      param['result'] = this.result;
      param['type'] = this.type;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['shopId'] = this.shopId;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getHygieneDetailPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    checkHygieneImg(list) {
      Dialog.open({
        title: '区域卫生照片',
        component: hygieneImgDialog,
        data: {
          imgList: list,
          width: '500px'
        },
        confirm: () => {

        }
      })
    },

    bitchUpdate() {
      if(this.idArray.length == 0) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请先选中需要审核的记录',
          type: 'warning'
        });
        return false
      }
      Dialog.open({
        title: '区域卫生照片',
        component: updateHygieneStateDialog,
        data: {
          idArray: this.idArray,
          hygieneId: this.hygieneId,
          width: '500px',
          bitchState: true,
        },
        confirm: () => {
          this.getPage()
        }
      })
    },

    updateState(row) {
      let arr = []
      arr.push(row.id)
      Dialog.open({
        title: '区域卫生照片',
        component: updateHygieneStateDialog,
        data: {
          idArray: arr,
          hygieneId: this.hygieneId,
          hygieneForm: row,
          width: '500px',
          bitchState: false,
        },
        confirm: () => {
          this.getPage()
        }
      })
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.id);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.id) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },


  },
  mounted() {
    this.getPage();
  }
}
</script>

<style>
.item-img {
  width: 80px;
  height: 80px;
}
</style>
